document.addEventListener('DOMContentLoaded', function () {

  const footer = document.querySelector('footer');
  const ear = document.querySelector('.otia-ears-test');
  if (!footer || !ear) return;

function update() {
  const rect = footer.getBoundingClientRect();
  const vh = window.innerHeight;

  // 🔥 on démarre PLUS TÔT (clé de ton problème)
  const start = vh * 1.0;        // ← démarre bien avant le footer
  const end = -rect.height;      // ← finit quand footer totalement passé

  let progress = (start - rect.top) / (start - end);
  progress = Math.max(0, Math.min(progress * 1.1, 1));

  const footerWidth = footer.clientWidth;
  const earWidth = ear.clientWidth;

  // on force la sortie complète à gauche
  const maxMove = footerWidth + earWidth;

  ear.style.transform = `translate3d(${-maxMove * progress}px,0,0)`;
}
  // scroll optimisé
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        update();
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', update);

  // recalcul après layout Shopify
  window.addEventListener('load', update);
  setTimeout(update, 300);

});
